import { IUserInfoModel } from "../../models/response/account/user-info"
export enum eAuthActionTypeIds {
    GET_USER_AUTH = "GET_USET_AUTH",
    SET_USER_AUTH = "SET_USER_AUTH",
    CLEAR_USER_AUTH = "CLER_USET_AUTH"
}
export interface IGetUserAuthAction {
    type: eAuthActionTypeIds.GET_USER_AUTH,
}
export interface ISetUserAuthAction {
    type: eAuthActionTypeIds.SET_USER_AUTH,
    payload: IUserInfoModel
}
export interface IClerUserAuthAction {
    type: eAuthActionTypeIds.CLEAR_USER_AUTH
}

export type IAuthActionTypes = IGetUserAuthAction | IClerUserAuthAction | ISetUserAuthAction